import type {
  ChannelSectionPayload,
  ChannelSectionsResponseChannel,
  ChannelSectionsResponseChannelPayload,
  IChannelSection,
  IChannelsWithSectionsResponse,
  IChannelsWithSectionsResponsePayload,
} from '../types'

export const normalizeChannelSectionChannel = (
  rawChannel: ChannelSectionsResponseChannelPayload
): ChannelSectionsResponseChannel => {
  return {
    ...rawChannel,
    _id: rawChannel._id || rawChannel.id,
    sectionId: rawChannel.sectionId ?? null,
    sequence: rawChannel.sequence ?? null,
    orderInSection: rawChannel.orderInSection ?? null,
  }
}

export const normalizeChannelSection = (rawSection: ChannelSectionPayload): IChannelSection => {
  return {
    ...rawSection,
    _id: rawSection._id || rawSection.id,
    parentSectionId: rawSection.parentSectionId ?? null,
    sequence: rawSection.sequence ?? null,
    orderInSection: rawSection.orderInSection ?? null,
  }
}

export const normalizeChannelsWithSectionsResponse = (
  response?: IChannelsWithSectionsResponsePayload
): IChannelsWithSectionsResponse => {
  return {
    channels: (response?.channels ?? []).map(channel => normalizeChannelSectionChannel(channel)),
    sections: (response?.sections ?? []).map(section => normalizeChannelSection(section)),
  }
}

export const createEmptyChannelSectionsResponse = (): IChannelsWithSectionsResponse => ({
  channels: [],
  sections: [],
})
